import GLightbox from 'glightbox';

(function () {
    const lightbox = GLightbox({});
})();